import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  useAccountSettings,
  useHookForm,
  useMerchantApiMutation,
} from "../../../hooks";
import { IPayoutSettings } from "../../../interfaces-and-types";
import { globalHandlerUtils } from "../../../utils";
import { payoutValidationSchema } from "./validationSchema";

import { View } from "./View";

export const PayoutSettings = () => {
  const navigate = useNavigate();

  const {
    // isLoading: isLoadingAccountSettings,
    isSuccess: isSuccessAccountSettings,
    data: accountSettings,
    refreshRemoteData: refreshAccountSettings,
  } = useAccountSettings();

  useEffect(() => {
    accountSettings && reset(accountSettings);
  }, []);

  useEffect(() => {
    if (isSuccessAccountSettings) {
      accountSettings && reset(accountSettings);
    }
  }, [isSuccessAccountSettings]);

  const initialFormValues: IPayoutSettings = {
    // is_instant_payout_enabled: false,
    settle_collections_to_wallet: false,
    enable_automatic_payout: false,
    automatic_payout_after_days: 1,

    // ...accountSettings,
  };

  const { isSuccess: isSuccessSaveSettings, mutate: saveSettings } =
    useMerchantApiMutation<IPayoutSettings, IPayoutSettings>(
      "savePayoutSettings"
    ).usePutMutation;

  const handleApiSubmit = (data: IPayoutSettings) => {
    saveSettings(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, reset, watch } = useHookForm(
    {
      initialFormValues,
      validationSchema: payoutValidationSchema,
      onValid: handleApiSubmit,
      onInvalid: handleError,
    }
  );

  const formValues = watch();

  useEffect(() => {
    if (isSuccessSaveSettings) {
      refreshAccountSettings();
    }
  }, [isSuccessSaveSettings]);

  const goBack = () => navigate("/settings");

  return (
    <View
      formValues={formValues}
      goBack={goBack}
      isDirty={isDirty}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
